import { useMemo } from 'react';
import { IconAlertTriangle, IconCheck } from './icons';
import { contrastRatio } from './color';

export default function ContrastIndicator({ textColor, backgroundColor }) {
  const ratio = useMemo(() => contrastRatio(textColor, backgroundColor), [textColor, backgroundColor]);
  const ok = ratio != null && ratio >= 4.5;
  const pillLabel = ratio == null ? 'Contraste —' : `Contraste ${ratio.toFixed(1)}:1`;
  return (
    <span className={`ContrastPill ${ratio == null ? '' : ok ? 'is-good' : 'is-bad'}`} title={`${pillLabel} (seuil conseillé: 4.5:1)`}>
      {ratio == null ? <IconAlertTriangle /> : ok ? <IconCheck /> : <IconAlertTriangle />}
      <span>{ratio == null ? '—' : ratio.toFixed(1)}</span>
    </span>
  );
}

